import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../_models/user';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User> =new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
    public currentUser: Observable<User> =this.currentUserSubject.asObservable();

    constructor( private router: Router, private http: HttpClient) {
 
    }

 
    login(username: string, password: string) {
      
        const headerDict = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
          }

          const requestOptions = {                                                                                                                                                                                 
            headers: new HttpHeaders(headerDict), 
          };
        return this.http.post<any>(environment.apiUrl+'/login', { username, password } ,requestOptions)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (user && user.token) {
                   
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    localStorage.setItem('link', "device");

                    this.currentUserSubject.next(user);
                }

                return user;
            }));
    }

    logout() {
        var user :any = localStorage.getItem('currentAdmin');
        if (user !== null ){
            // localStorage.removeItem('currentUser');
            // localStorage.removeItem('currentAdmin');
            localStorage.setItem('currentUser', user);
            localStorage.removeItem('currentAdmin');
            // this.currentUserSubject.next(user);
            // this.router.navigate(['/admin/device']);
            // window.location.reload();
            setTimeout(() => {
                window.location.replace('/admin/companypartner');
            },500);
        }else {
            // remove user from local storage to log user out
            localStorage.removeItem('currentAdmin');
            localStorage.removeItem('currentUser');
            localStorage.removeItem('link');
            this.currentUserSubject.next(null);
            sessionStorage.clear();
            this.router.navigate(['/login']);
        }
        
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

}